import MuiListItem, { ListItemProps } from "@mui/material/ListItem";

const ListItem: React.FC<ListItemProps> = MuiListItem;

export default ListItem;

export type { ListItemProps };
